import React, { useState, useRef, useEffect } from 'react';

function LabelsEditor({ value, onChange, disabled, onFetchLabels }) {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [allLabels, setAllLabels] = useState([]);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const labels = Array.isArray(value) ? value : [];

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
    // Fetch labels once
    if (onFetchLabels) {
      setLoading(true);
      onFetchLabels()
        .then(result => {
          const labelValues = Array.isArray(result) ? result
            : Array.isArray(result?.values) ? result.values
            : [];
          setAllLabels(labelValues);
        })
        .catch(() => setAllLabels([]))
        .finally(() => setLoading(false));
    }
  }, []);

  useEffect(() => {
    if (!inputValue.trim()) {
      setSuggestions([]);
      return;
    }
    const query = inputValue.toLowerCase();
    const filtered = allLabels
      .filter(l => {
        const labelStr = typeof l === 'string' ? l : l.label || l.name || '';
        return labelStr.toLowerCase().includes(query) && !labels.includes(labelStr);
      })
      .slice(0, 10);
    setSuggestions(filtered);
  }, [inputValue, allLabels, labels]);

  const addLabel = (label) => {
    const labelStr = typeof label === 'string' ? label : label.label || label.name || '';
    if (labelStr && !labels.includes(labelStr)) {
      onChange([...labels, labelStr]);
    }
    setInputValue('');
  };

  const removeLabel = (label) => {
    onChange(labels.filter(l => l !== label));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue.trim()) {
      e.preventDefault();
      addLabel(inputValue.trim());
    } else if (e.key === 'Backspace' && !inputValue && labels.length > 0) {
      removeLabel(labels[labels.length - 1]);
    }
  };

  return (
    <div className="field-editor-labels-wrapper">
      <div className="field-editor-tags">
        {labels.map(label => (
          <span key={label} className="field-editor-tag">
            {label}
            <button
              className="field-editor-tag-remove"
              onClick={() => !disabled && removeLabel(label)}
              type="button"
            >
              ×
            </button>
          </span>
        ))}
        <input
          ref={inputRef}
          type="text"
          className="field-editor-tag-input"
          placeholder={labels.length === 0 ? 'Add label...' : ''}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
      </div>
      {loading && <div className="field-editor-loading">Loading labels...</div>}
      {suggestions.length > 0 && (
        <div className="field-editor-options-list">
          {suggestions.map(s => {
            const labelStr = typeof s === 'string' ? s : s.label || s.name || '';
            return (
              <div
                key={labelStr}
                className="field-editor-option"
                onClick={() => !disabled && addLabel(s)}
              >
                <span className="field-editor-option-label">{labelStr}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default LabelsEditor;
